import { css } from "@emotion/css"

type Props = {
  children: React.ReactNode
  label: string
}

const InputLabel = ({ label, children }: Props) => {
  return (
    <label className={styles.label}>
      {label}
      <span>{children}</span>
    </label>
  )
}

export default InputLabel

const styles = {
  label: css`
    display: flex;
    column-gap: 5px;
    align-items: center;
  `,
}
